<template>
    <small>
        <b-overlay :show="!items" class="overlay" opacity="1">
            <b-table :fields="fields" :items="items" small bordered table-class="print-table small-text" class="mb-0" show-empty>
                <template #empty>
                    <div class="text-center my-2 fs-5">
                        No hay denuncias que coincidan con los criterios de búsqueda
                    </div>
                </template>
            
                <template #cell(information)="data">
                    <div class="information-container">
                        <div><small><b>Nombre afectado</b>: {{ data.item.accuserNombre }}</small></div>
                        <div><small><b>Correo afectado</b>: {{ data.item.accuserCorreo }}</small></div>
                        <div><small><b>RUT afectado</b>: {{ data.item.accuserRut }}</small></div>
                        <div><small><b>Tipo de denuncia</b>: {{ data.item.denunciationType }}</small></div>
                        <div><small><b>Medidas de protección solicitadas</b>: {{formatBoolean(data.item.preventive)}}</small></div>
                        <div><small><b>Estado</b>: {{ data.item.approval }}</small></div>
                        <div v-if="data.item.approvalItem">
                            <small><b>Procesado por</b>: {{ data.item.approvalItem.approverMail }}</small>
                            <br>
                            <small><b>Justificación</b>: {{ data.item.approvalItem.reason }}</small>
                        </div>
                    </div>
                </template>

                <template #cell(denouncedPeople)="data">
                    <small>
                        <ul class="minimal-list">
                            <li v-for="(person, index) in data.item.reported" :key="index">
                                {{ person }}
                            </li>
                        </ul>
                    </small>
                </template>

                <template #cell(comments)="data">
                    <small>
                        <ul class="minimal-list">
                            <li v-for="(comment, index) in data.item.comments" :key="index">
                                {{ formatComment(comment)}}
                            </li>
                        </ul>
                    </small>
                </template>
            </b-table>
        </b-overlay>
    </small>
</template>

<script>
import { formatRut, formatDateTime, formatComment, formatBoolean} from '@/plugins/complianceScripts/index.js'

export default {
    name: 'KarinReportTable',

    props: {
        items: Array,
    },

    data() {
        return {
            fields: [
                {
                    key: 'information',
                    label: 'Información',
                    thClass: "text-center col-3",
                    tdClass: "text-left text-justify"
                },
                {
                    key: 'descripcion',
                    label: 'Detalle',
                    thClass: "text-center col-3",
                    tdClass: "text-justify"
                },
                {
                    key: 'denouncedPeople',
                    label: 'Personas denunciadas',
                    thClass: "text-center col-3",
                    tdClass: "text-left",
                },
                {
                    key: 'comments',
                    label: 'Comentarios',
                    thClass: "text-center col-3",
                    tdClass: "text-left",
                },
            ]
        }
    },

    methods: {
        formatDateTime,
        formatComment,
        formatBoolean,
        formatRut,
    },
}
</script>

<style scoped>
.small-text {
    font-size: 0.875em;
}

.small-text th {
    font-size: 0.875em;
    font-weight: bold;
}

.information-container > div {
    margin: 0.2rem 0;
}

.minimal-list {
    list-style: none;
    padding-left: 0.2rem;
    margin: 0.2rem 0;
    padding-left: 1em;
}

.minimal-list li::before {
    content: "- ";
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}

hr {
    margin: 0.2rem 0;
    color: grey;
}
</style>